import {
	FlatList,
	StyleSheet,
	Text,
	View,
	RefreshControl,
	TextInput,
	TouchableOpacity,
	Image,
} from 'react-native';
import React, { useEffect, useState } from 'react';
import Header from '../../Components/common/Header';
import { userStorage } from '../../utilities/Utility';
import ApiHandler from '../../API/ApiHandler';
import Loader from '../../Components/Loader';

import { FontAwesome } from '@expo/vector-icons';
import InventoryCard from '../../Components/InventoryCard';

const InventoryList = ({ navigation }) => {
	const [endReached, setEndReached] = useState(false);
	const [isRefreshing, setIsRefreshing] = useState(false);
	const [inventoryList, setInventoryList] = useState([]);
	const [offset, setOffset] = useState(0);
	const [emptyLead, setEmptyLead] = useState(false);
	const [loader, setLoader] = useState(true);
	const [totalList, setTotalList] = useState('');
	const [searchText, setSearchText] = useState('');

	useEffect(() => {
		setLoader(true);
		getInventory(0, inventoryList, '');
	}, []);

	const getInventory = async (offset, updatedList, searchText) => {
		let user = await userStorage();
		const response = await ApiHandler.getInventoryList(user, offset, searchText);
		// console.log('from opportunity page', response.data);

		if (response.status == 200) {
			response.data.list &&
			response.data.list.length == 0 &&
			updatedList.length == 0
				? setEmptyLead(true)
				: setEmptyLead(false);
			setInventoryList([...updatedList, ...response.data.list]);
			setTotalList(response.data.total);

			setOffset(offset + 20);
		} else {
			console.log('error while fetching leads List');
		}

		// console.log(response.data.list);
		setIsRefreshing(false);
		setLoader(false);
	};
	const handleRefresh = async () => {
		getInventory(0, [], '');
		setOffset(0);
	};
	const loadMoreData = async () => {
		console.log('loadmore... calling');
		if (!endReached && inventoryList.length % 20 == 0) {
			setEndReached(true);
			console.log('load more Leads list', inventoryList.length);
			getInventory(offset, inventoryList, '');
		}
	};

	return (
		<View style={{ flex: 1, backgroundColor: 'white', paddingTop: 30 }}>
	
			<Header />
			<>
				{loader ? (
					<Loader />
				) : (
					<>
						<View
							style={{
								flexDirection: 'row',
								alignItems: 'center',
								paddingHorizontal: 10,
								marginVertical: 6,
							}}
						>
							<TextInput
								placeholder="Please Search Here"
								// keyboardType="phone-pad"
								style={{
									flex: 1,
									alignItems: 'center',
									borderWidth: 1,
									borderColor: 'rgba(0,0,0,0.4)',
									borderRadius: 6,
									paddingLeft: 8,
									paddingVertical: 6,
								}}
								value={searchText}
								onChangeText={(e) => {
									setSearchText(e);
								}}
							/>
							<TouchableOpacity
								style={{
									...styles.button,
									backgroundColor: '#26b2d1',
								}}
								onPress={() => getInventory(0, [], searchText)}
							>
								<Text style={{ color: 'white' }}>Search</Text>
							</TouchableOpacity>
						</View>
						<Text
							style={{
								fontWeight: '600',
								fontSize: 16,
								paddingHorizontal: 10,
								paddingVertical: 6,
							}}
						>
							{inventoryList.length == 0
								? 'Total Inventories (0)'
								: 'Total Inventories (' +
								  inventoryList.length +
								  ' of ' +
								  totalList +
								  ')'}
						</Text>
						{/* <ApiError
							responseCode={responseCode}
							setResponseCode={setResponseCode}
						/> */}
						{emptyLead ? (
							<FlatList
								data={['demo']}
								keyExtractor={(i, j) => j}
								showsVerticalScrollIndicator={false}
								renderItem={({ item }) => {
									return (
										<View
											style={{ alignItems: 'center', justifyContent: 'center' }}
										>
											<Image
												style={{ height: 360, width: 300, marginTop: 80 }}
												source={require('../../assets/images/No_Leads.png')}
											/>
											<Text
												style={{
													fontWeight: '600',
													fontSize: 16,
												}}
											>
												No Inventories Found
											</Text>
										</View>
									);
								}}
								refreshControl={
									<RefreshControl
										refreshing={isRefreshing}
										onRefresh={() => {
											handleRefresh();
										}}
									/>
								}

								// ListFooterComponent={renderFooter}
							/>
						) : (
							<FlatList
								data={inventoryList}
								keyExtractor={(i, j) => j}
								showsVerticalScrollIndicator={false}
								renderItem={({ item }) => {
									return (
										<InventoryCard item={item} navigation={navigation} />
									);
								}}
								refreshControl={
									<RefreshControl
										refreshing={isRefreshing}
										onRefresh={() => {
											handleRefresh();
										}}
									/>
								}
								onEndReached={loadMoreData}
								onMomentumScrollBegin={() => {
									setEndReached(false);
								}}
								onEndReachedThreshold={0.3}
								// ListFooterComponent={renderFooter}
							/>
						)}
					</>
				)}
			</>
		</View>
	);
};

export default InventoryList;

const styles = StyleSheet.create({
	button: {
		paddingVertical: 10,
		marginLeft: 3,
		paddingHorizontal: 15,
		borderRadius: 4,
		alignSelf: 'flex-end',
	},
});
